// eslint-disable
import { ComponentClass, FunctionComponent } from 'react';

import AccountCircleOff from './account_circle_off.svg';
import AccountCircleOn from './account_circle_on.svg';
import AddPicture from './add_picture.svg';
import ArrowDown from './arrow_down.svg';
import ArrowLeft from './arrow_left.svg';
import ArrowRight from './arrow_right.svg';
import ArrowUp from './arrow_up.svg';
import AttachFile from './attach_file.svg';
import AutoAwesome from './auto_awesome.svg';
import AutoFixHigh from './auto_fix_high.svg';
import Cached from './cached.svg';
import ChatBubbleNow from './chat_bubble_now.svg';
import ChatBubbleOff from './chat_bubble_off.svg';
import ChatBubbleOn from './chat_bubble_on.svg';
import CheckBoxOff from './check_box_off.svg';
import CheckBoxOn from './check_box_on.svg';
import CheckCircleOff from './check_circle_off.svg';
import CheckCircleOn from './check_circle_on.svg';
import Check from './check.svg';
import CloseCircle from './close_circle.svg';
import Close from './close.svg';
import CloudDownloadOff from './cloud_download_off.svg';
import CloudDownloadOn from './cloud_download_on.svg';
import CreditCard from './credit_card.svg';
import DashboardOff from './dashboard_off.svg';
import DashboardOn from './dashboard_on.svg';
import DeleteOff from './delete_off.svg';
import DeleteOn from './delete_on.svg';
import Download from './download.svg';
import DragHandle from './drag_handle.svg';
import DropArrowDown from './drop_arrow_down.svg';
import DropArrowUp from './drop_arrow_up.svg';
import Edit from './edit.svg';
import Email from './email.svg';
import EventOff from './event_off.svg';
import EventOn from './event_on.svg';
import ExploreOff from './explore_off.svg';
import ExploreOn from './explore_on.svg';
import FavoriteOff from './favorite_off.svg';
import FavoriteOn from './favorite_on.svg';
import FlagOff from './flag_off.svg';
import FlagOn from './flag_on.svg';
import FolderOff from './folder_off.svg';
import FolderOn from './folder_on.svg';
import Graph from './graph.svg';
import HelpOutline from './help_outline.svg';
import InsertComment from './insert_comment.svg';
import InsertLink from './insert_link.svg';
import Insta from './insta_icon.svg';
import LineDownload from './line_download.svg';
import List from './list.svg';
import LockOff from './lock_off.svg';
import LockOn from './lock_on.svg';
import Memory from './memory.svg';
import Menu from './menu.svg';
import MoreHoriz from './more_horiz.svg';
import MoreVert from './more_vert.svg';
import NaverBlog from './naver_blog.svg';
import Navigation from './navigation.svg';
import NotificationNow from './notification_now.svg';
import NotificationOff from './notification_off.svg';
import NotificationOn from './notification_on.svg';
import OfferOff from './offer_off.svg';
import OfferOn from './offer_on.svg';
import OfflineBoltOff from './offline_bolt_off.svg';
import OfflineBoltOn from './offline_bolt_on.svg';
import OutLink from './out_link.svg';
import Picture from './picture.svg';
import Pin from './pin.svg';
import Public from './public.svg';
import RadioButtonOff from './radio_button_off.svg';
import RadioButtonOn from './radio_button_on.svg';
import RankingOff from './ranking_off.svg';
import RankingOn from './ranking_on.svg';
import RemoveCircleOff from './remove_circle_off.svg';
import RemoveCircleOn from './remove_circle_on.svg';
import RedEyeOff from './remove_red_eye_off.svg';
import RedEyeOn from './remove_red_eye_on.svg';
import Search from './search.svg';
import Settings from './settings.svg';
import ShoppingCartOff from './shopping_cart_off.svg';
import ShoppingCartOn from './shopping_cart_on.svg';
import SideBarOff from './sidebar_left_off.svg';
import SkipNext from './skip_next.svg';
import SkipPrev from './skip_prev.svg';
import StarOff from './star_off.svg';
import StarOn from './star_on.svg';
import SupportAgent from './support_agent.svg';
import Tiktok from './tiktok.svg';
import Timer from './timer.svg';
import ToggleOff from './toggle_off.svg';
import ToggleOn from './toggle_on.svg';
import Tune from './tune.svg';
import UploadFile from './upload_file.svg';
import Video from './video.svg';
import Verified from './verified.svg';
import Warning from './warning.svg';
import YoutubeShorts from './youtube_shorts.svg';
import Youtube from './youtube.svg';

interface IStringKey {
	[key: string]: any;
}

interface IIconIndex extends IStringKey {
	AccountCircleOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	AccountCircleOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	AddPicture: string | FunctionComponent<any> | ComponentClass<any, any>;
	ArrowDown: string | FunctionComponent<any> | ComponentClass<any, any>;
	ArrowLeft: string | FunctionComponent<any> | ComponentClass<any, any>;
	ArrowRight: string | FunctionComponent<any> | ComponentClass<any, any>;
	ArrowUp: string | FunctionComponent<any> | ComponentClass<any, any>;
	AttachFile: string | FunctionComponent<any> | ComponentClass<any, any>;
	AutoAwesome: string | FunctionComponent<any> | ComponentClass<any, any>;
	AutoFixHigh: string | FunctionComponent<any> | ComponentClass<any, any>;
	Cached: string | FunctionComponent<any> | ComponentClass<any, any>;
	ChatBubbleNow: string | FunctionComponent<any> | ComponentClass<any, any>;
	ChatBubbleOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	ChatBubbleOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	CheckBoxOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	CheckBoxOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	CheckCircleOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	CheckCircleOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	Check: string | FunctionComponent<any> | ComponentClass<any, any>;
	CloseCircle: string | FunctionComponent<any> | ComponentClass<any, any>;
	Close: string | FunctionComponent<any> | ComponentClass<any, any>;
	CloudDownloadOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	CloudDownloadOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	CreditCard: string | FunctionComponent<any> | ComponentClass<any, any>;
	DashboardOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	DashboardOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	DeleteOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	DeleteOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	Download: string | FunctionComponent<any> | ComponentClass<any, any>;
	DragHandle: string | FunctionComponent<any> | ComponentClass<any, any>;
	DropArrowDown: string | FunctionComponent<any> | ComponentClass<any, any>;
	DropArrowUp: string | FunctionComponent<any> | ComponentClass<any, any>;
	Edit: string | FunctionComponent<any> | ComponentClass<any, any>;
	Email: string | FunctionComponent<any> | ComponentClass<any, any>;
	EventOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	EventOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	ExploreOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	ExploreOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	FavoriteOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	FavoriteOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	FlagOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	FlagOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	FolderOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	FolderOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	Graph: string | FunctionComponent<any> | ComponentClass<any, any>;
	HelpOutline: string | FunctionComponent<any> | ComponentClass<any, any>;
	InsertComment: string | FunctionComponent<any> | ComponentClass<any, any>;
	InsertLink: string | FunctionComponent<any> | ComponentClass<any, any>;
	Insta: string | FunctionComponent<any> | ComponentClass<any, any>;
	LineDownload: string | FunctionComponent<any> | ComponentClass<any, any>;
	List: string | FunctionComponent<any> | ComponentClass<any, any>;
	LockOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	LockOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	Memory: string | FunctionComponent<any> | ComponentClass<any, any>;
	Menu: string | FunctionComponent<any> | ComponentClass<any, any>;
	MoreHoriz: string | FunctionComponent<any> | ComponentClass<any, any>;
	MoreVert: string | FunctionComponent<any> | ComponentClass<any, any>;
	NaverBlog: string | FunctionComponent<any> | ComponentClass<any, any>;
	Navigation: string | FunctionComponent<any> | ComponentClass<any, any>;
	NotificationNow: string | FunctionComponent<any> | ComponentClass<any, any>;
	NotificationOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	NotificationOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	OfferOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	OfferOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	OfflineBoltOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	OfflineBoltOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	OutLink: string | FunctionComponent<any> | ComponentClass<any, any>;
	Picture: string | FunctionComponent<any> | ComponentClass<any, any>;
	Pin: string | FunctionComponent<any> | ComponentClass<any, any>;
	Public: string | FunctionComponent<any> | ComponentClass<any, any>;
	RadioButtonOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	RadioButtonOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	RankingOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	RankingOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	RemoveCircleOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	RemoveCircleOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	RedEyeOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	RedEyeOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	Search: string | FunctionComponent<any> | ComponentClass<any, any>;
	Settings: string | FunctionComponent<any> | ComponentClass<any, any>;
	ShoppingCartOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	ShoppingCartOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	SideBarOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	SkipNext: string | FunctionComponent<any> | ComponentClass<any, any>;
	SkipPrev: string | FunctionComponent<any> | ComponentClass<any, any>;
	StarOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	StarOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	SupportAgent: string | FunctionComponent<any> | ComponentClass<any, any>;
	Tiktok: string | FunctionComponent<any> | ComponentClass<any, any>;
	Timer: string | FunctionComponent<any> | ComponentClass<any, any>;
	ToggleOff: string | FunctionComponent<any> | ComponentClass<any, any>;
	ToggleOn: string | FunctionComponent<any> | ComponentClass<any, any>;
	Tune: string | FunctionComponent<any> | ComponentClass<any, any>;
	UploadFile: string | FunctionComponent<any> | ComponentClass<any, any>;
	Video: string | FunctionComponent<any> | ComponentClass<any, any>;
	Verified: string | FunctionComponent<any> | ComponentClass<any, any>;
	Warning: string | FunctionComponent<any> | ComponentClass<any, any>;
	YoutubeShorts: string | FunctionComponent<any> | ComponentClass<any, any>;
	Youtube: string | FunctionComponent<any> | ComponentClass<any, any>;
}

const Icon: IIconIndex = {
	AccountCircleOff,
	AccountCircleOn,
	AddPicture,
	ArrowDown,
	ArrowLeft,
	ArrowRight,
	ArrowUp,
	AttachFile,
	AutoAwesome,
	AutoFixHigh,
	Cached,
	ChatBubbleNow,
	ChatBubbleOff,
	ChatBubbleOn,
	CheckBoxOff,
	CheckBoxOn,
	CheckCircleOff,
	CheckCircleOn,
	Check,
	CloseCircle,
	Close,
	CloudDownloadOff,
	CloudDownloadOn,
	CreditCard,
	DashboardOff,
	DashboardOn,
	DeleteOff,
	DeleteOn,
	Download,
	DragHandle,
	DropArrowDown,
	DropArrowUp,
	Edit,
	Email,
	EventOff,
	EventOn,
	ExploreOff,
	ExploreOn,
	FavoriteOff,
	FavoriteOn,
	FlagOff,
	FlagOn,
	FolderOff,
	FolderOn,
	Graph,
	HelpOutline,
	InsertComment,
	InsertLink,
	Insta,
	LineDownload,
	List,
	LockOff,
	LockOn,
	Memory,
	Menu,
	MoreHoriz,
	MoreVert,
	NaverBlog,
	Navigation,
	NotificationNow,
	NotificationOff,
	NotificationOn,
	OfferOff,
	OfferOn,
	OfflineBoltOff,
	OfflineBoltOn,
	OutLink,
	Picture,
	Pin,
	Public,
	RadioButtonOff,
	RadioButtonOn,
	RankingOff,
	RankingOn,
	RemoveCircleOff,
	RemoveCircleOn,
	RedEyeOff,
	RedEyeOn,
	Search,
	Settings,
	ShoppingCartOff,
	ShoppingCartOn,
	SideBarOff,
	SkipNext,
	SkipPrev,
	StarOff,
	StarOn,
	SupportAgent,
	Tiktok,
	Timer,
	ToggleOff,
	ToggleOn,
	Tune,
	UploadFile,
	Video,
	Verified,
	Warning,
	YoutubeShorts,
	Youtube,
};

export default Icon;
